// utils/confirmToast.js
import { toast } from "react-hot-toast";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

export const confirmToast = ({
  title = "Жоюды растау",
  message = "Бұл пайдаланушыны жойғыңыз келетініне сенімдісіз бе?",
  confirmText = "ИӘ, ЖОЮ",
  cancelText = "БАС ТАРТУ",
} = {}) =>
  new Promise((resolve) => {
    const id = toast.custom(
      (t) => (
        <div
          className={`
            max-w-md w-full bg-white shadow-2xl rounded-b-3xl border border-gray-100
            backdrop-blur-sm transition-all duration-300 ease-out transform
            ${
              t.visible
                ? "opacity-100 scale-100 translate-y-0"
                : "opacity-0 scale-90 -translate-y-4"
            }
          `}
          style={{
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.98) 100%)",
          }}
        >
          {/* Top accent line */}
          <div className="h-1 bg-gradient-to-r from-red-500 via-red-400 to-orange-400 rounded-t-3xl"></div>

          <div className="p-6">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className="w-14 h-14 bg-red-50 rounded-2xl flex items-center justify-center animate-pulse">
                  <ExclamationTriangleIcon className="h-8 w-8 text-red-500" />
                </div>
              </div>
              <div className="ml-4 flex-1">
                <h3 className="text-lg font-bold text-gray-900 mb-1">
                  {title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {message}
                </p>
              </div>
            </div>

            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={() => {
                  toast.dismiss(id);
                  resolve(false);
                }}
                className="px-6 py-2.5 rounded-xl border border-gray-200 text-gray-700 font-medium
                         hover:bg-gray-50 hover:border-gray-300 hover:shadow-md
                         transition-all duration-200 ease-out transform hover:scale-105
                         active:scale-95"
              >
                {cancelText}
              </button>
              <button
                onClick={() => {
                  toast.dismiss(id);
                  resolve(true);
                }}
                className="px-6 py-2.5 rounded-xl font-medium text-white
                         bg-gradient-to-r from-red-500 to-red-600 
                         hover:from-red-600 hover:to-red-700 
                         hover:shadow-lg hover:shadow-red-500/25
                         transition-all duration-200 ease-out transform hover:scale-105
                         active:scale-95"
              >
                {confirmText}
              </button>
            </div>
          </div>
        </div>
      ),
      {
        duration: Infinity,
        position: "top-center",
        id: `confirm-${Date.now()}`,
      }
    );
  });
